import Phaser from 'phaser';
import { COLORS } from 'helpers/constants';

const GoldButton = (scene, options) => {
  const { text, action, x, y, width, height, muted, scaleMultiplier } = options;
  let scale = scene.game.defaultZoom * (scaleMultiplier || 1);
  const container = scene.add.container();
  container.action = action;

  //button
  const button = scene.add
    .nineslice(
      x,
      y,
      width, // overall width
      height, // overall height
      'ui_button_9s', // image key
      3 // symmetrical corner size
    )
    .setScale(scale)
    .setOrigin(0.5);
  container.add(button);

  const buttonDown = scene.add
    .nineslice(
      x,
      y,
      width, // overall width
      height, // overall height
      'ui_button_9s_down', // image key
      3 // symmetrical corner size
    )
    .setScale(scale)
    .setOrigin(0.5)
    .setAlpha(0);
  container.add(buttonDown);

  const clickBoxDown = pointer => {
    buttonDown.setAlpha(1);
    button.setAlpha(0);
    textLabel.setColor(COLORS.LIGHT_YELLOW);
    if (!muted) {
      scene.game.sfx.click.play();
    }
  };
  const clickBoxUp = pointer => {
    buttonDown.setAlpha(0);
    button.setAlpha(1);
    textLabel.setColor(COLORS.BROWN);
    container.action();
  };

  const mouseOver = pointer => {
    scene.game.soundManager.playSfx('pointerover');
    textLabel.setColor(COLORS.GOLD_BUTTON_HOVER);
  };

  const mouseOut = pointer => {
    buttonDown.setAlpha(0);
    button.setAlpha(1);
    textLabel.setColor(COLORS.BROWN);
  };

  let rect = new Phaser.Geom.Rectangle(
    x - (width * scale) / 2,
    y - (height * scale) / 2,
    width * scale,
    height * scale
  );
  let clickHitbox = scene.add.graphics();
  clickHitbox.lineStyle(3, 0x5b87a1, 1);
  clickHitbox.fillStyle(0x1f272c, 0);
  clickHitbox.fillRectShape(rect);
  clickHitbox
    .setInteractive(rect, Phaser.Geom.Rectangle.Contains)
    .on('pointerover', mouseOver)
    .on('pointerout', mouseOut)
    .on('pointerdown', clickBoxDown)
    .on('pointerup', clickBoxUp);
  container.add(clickHitbox);

  // text
  const textLabel = scene.add
    .text(x, y - 1 * scale, text, {
      fontSize: `${scale * 8}px`,
      color: COLORS.BROWN,
      fontFamily: 'pixelMix'
    })
    .setOrigin(0.5)
    .setResolution(10);
  container.add(textLabel);

  container.setAction = action => {
    container.action = action;
  };

  container.setText = newText => {
    textLabel.setText(newText);
  };

  container.getText = () => {
    return textLabel._text;
  };

  container.setSelected = selected => {
    if (
      !textLabel ||
      !textLabel.active ||
      !textLabel.scene ||
      !textLabel.frame?.source
    ) {
      return;
    }
    textLabel.setColor(selected ? COLORS.GOLD_BUTTON_HOVER : COLORS.BROWN);
  };

  container.resetPosition = (x, y) => {
    scale = scene.game.defaultZoom * (scaleMultiplier || 1);
    button.setPosition(x, y).setScale(scale);
    buttonDown.setPosition(x, y).setScale(scale);

    let newRect = new Phaser.Geom.Rectangle(
      x - (width * scale) / 2,
      y - (height * scale) / 2,
      width * scale,
      height * scale
    );
    clickHitbox.clear();
    clickHitbox.destroy();
    clickHitbox = scene.add.graphics();
    clickHitbox.lineStyle(3, 0x5b87a1, 1);
    clickHitbox.fillStyle(0x1f272c, 0);
    clickHitbox.fillRectShape(newRect);
    clickHitbox
      .setInteractive(newRect, Phaser.Geom.Rectangle.Contains)
      .on('pointerdown', clickBoxDown)
      .on('pointerup', clickBoxUp);
    container.add(clickHitbox);

    textLabel
      .setPosition(x, y - 1 * scale)
      .setStyle({ fontSize: `${scale * 8}px` });
  };

  return container;
};

export default GoldButton;
